import { render, staticRenderFns } from "./ProductInput.vue?vue&type=template&id=2a07b0ce&scoped=true&"
import script from "./ProductInput.vue?vue&type=script&lang=js&"
export * from "./ProductInput.vue?vue&type=script&lang=js&"
import style0 from "./ProductInput.vue?vue&type=style&index=0&id=2a07b0ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a07b0ce",
  null
  
)

export default component.exports